import { linkedInStore } from 'owa-linkedin';

export default function isUserBoundToLinkedIn(): boolean {
    return linkedInStore().status == 'Bound';
}
